import { User } from 'firebase/auth';
import { useEffect } from 'react';
import CareerSeeker from 'wwg-utilities/dist/collections/career-seeker';
import { useAuth } from '../providers/authProvider';

const initUser = (user: User | null, seeker: CareerSeeker | null) => {
  const { setUser, setSeeker } = useAuth();
  useEffect(() => {
    setUser(user);
    setSeeker(seeker);
  }, []);
};

export default initUser;
